import careerGoals, { CareerGoalType } from "../../types/user/careerGoals";

class CareerGoalClient {
  public async getAllGoals(): Promise<CareerGoalType[]> {
    return [...careerGoals];
  }
}

export default CareerGoalClient;
